<template>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_327_2756)">
            <rect width="24" height="24" transform="translate(4 2)" fill="white"/>
            <path d="M9 8H6L6 9H9L9 12L10 12L10 9L13 9V8H10V5L9 5V8Z" fill="#00458D"/>
            <path d="M16 6.5H20.5L23.5 14.5M23.5 14.5H24.5C25.0523 14.5 25.5 14.9477 25.5 15.5V20.5C25.5 21.0523 25.0523 21.5 24.5 21.5H7.5C6.94772 21.5 6.5 21.0523 6.5 20.5V15.5C6.5 14.9477 6.94772 14.5 7.5 14.5H23.5Z" stroke="#333333"/>
            <path d="M12 11.5H22.5" stroke="#333333"/>
            <path d="M15 8.5H21" stroke="#333333"/>
            <path d="M14 16.5H18" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <filter id="filter0_d_327_2756" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="2"/>
                <feGaussianBlur stdDeviation="2"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_327_2756"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_327_2756" result="shape"/>
            </filter>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'SVGNewSeparator',
};
</script>

<style scoped lang="scss">

</style>
